/*globals
    define:false
*/

define(['helpers/namespace/namespace'], function (ns) {
    'use strict';

    /** @namespace Helpers.StringUtil */
    return ns('Helpers.StringUtil', {
        contains: function (text, str) {
            return text.indexOf(str) !== -1;
        },

        /**
         * Adapted from
         * http://ajaxcontroltoolkit.codeplex.com/SourceControl/latest#Client/MicrosoftAjax/Extensions/String.js
         *
         * Copyright (c) 2009, CodePlex Foundation
         * All rights reserved.
         *
         * Redistribution and use in source and binary forms, with or without modification, are permitted provided that
         * the following conditions are met:
         *
         * * Redistributions of source code must retain the above copyright notice, this list of conditions and the
         *   following disclaimer.
         *
         * * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the
         *   following disclaimer in the documentation and/or other materials provided with the distribution.
         *
         * * Neither the name of CodePlex Foundation nor the names of its contributors may be used to endorse or
         *   promote products derived from this software without specific prior written permission.
         *
         * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
         * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
         * PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
         * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
         * PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
         * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
         * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
         * DAMAGE.
         */
        format: function () {
            var result = '';
            var format = arguments[0];

            var i = 0;
            while (true) {
                // Find the next opening or closing brace
                var open = format.indexOf('{', i);
                var close = format.indexOf('}', i);
                if (open < 0 && close < 0) {
                    // Not found: copy the end of the string and break
                    result += format.slice(i);
                    break;
                }
                if (close > 0 && (close < open || open < 0)) {
                    if (format.charAt(close + 1) !== '}') {
                        throw new Error('format stringFormatBraceMismatch');
                    }

                    result += format.slice(i, close + 1);
                    i = close + 2;
                    continue;
                }

                // Copy the string before the brace
                result += format.slice(i, open);
                i = open + 1;

                // Check for double braces (which display as one and are not arguments)
                if (format.charAt(i) === '{') {
                    result += '{';
                    i+=1;
                    continue;
                }

                if (close < 0) {
                    throw new Error('format stringFormatBraceMismatch');
                }

                // Find the closing brace

                // Get the string between the braces, and split it around the ':' (if any)
                var brace = format.substring(i, close);
                var colonIndex = brace.indexOf(':');
                var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10) + 1;

                if (isNaN(argNumber)) {
                    throw new Error('format stringFormatInvalid');
                }

                var arg = arguments[argNumber];
                if (typeof (arg) === 'undefined' || arg === null) {
                    arg = '';
                }

                result += arg.toString();

                i = close + 1;
            }

            return result;
        }
    });
});
